import { BaseDto } from './base.dto';
import { MerchantDto } from './merchant.dto';
import { ProductWastageAuditDetailDto } from './productWastageAuditDetail.dto';

export class ProductWastageAuditDto extends BaseDto {
    weekNo: number;
    year: number;
    wastageDay?: string;
    closed: boolean;
    merchant: MerchantDto;
    stockWastageDetails?: ProductWastageAuditDetailDto[];
}
